module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wake-up"
  }, [_c('span'), _vm._v(" "), _c('p', [_vm._v("Opening All Football...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec7b6e70","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AppWakeUp.vue
// module id = 838
// module chunks = 14